import React, { useState, useEffect } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'

import { Link } from 'react-router-dom'
import { IoIosArrowForward, IoIosArrowBack } from 'react-icons/io'
import { useDispatch } from 'react-redux'
import { price_range_product } from '../store/reducers/homeReducer'
import { useTranslation } from 'react-i18next'
import cookies from 'js-cookie'
import Categorys from '../components/Categorys'
import UseSnus from '../components/UseSnus'

const Categories = () => {
  const { t, i18n } = useTranslation()
  const dispatch = useDispatch()
  const currentLanguage = i18n.language
  const isRTL = currentLanguage === 'ar' || currentLanguage === 'kr'
  const [currentLanguageCode, setCurrentLanguageCode] = useState(
    cookies.get('i18next') || 'en'
  )

  useEffect(() => {
    setCurrentLanguageCode(cookies.get('i18next') || 'en')
  }, [currentLanguageCode, t, dispatch])

  useEffect(() => {
    dispatch(price_range_product())
  }, [])

  return (
    <div>
      <Header />
      <section className=" mt-5 bg-cover bg-no-repeat relative bg-left">
        <div className="absolute left-0 top-0 w-full h-full bg-[#2422228a]">
          <div className="w-[65%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white"></div>
          </div>
        </div>
      </section>
      <section>
        <div className=" bg-slate-100 py-5 mb-2">
          <div className="w-[68%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex justify-start items-center text-md text-slate-600 w-full">
              <Link to="/"> {t('home.home')}</Link>
              <span>
                <span>
                  {isRTL ? <IoIosArrowBack /> : <IoIosArrowForward />}
                </span>
              </span>
              <span>{t('home.categoreis')}{' '}</span>
            </div>
          </div>
        </div>
      </section>

      <Categorys />
      <div className="py-[15px]">
        <UseSnus />
      </div>

      <Footer />
    </div>
  )
}

export default Categories
